import React from "react";
import cross from "../../assets/Menu/cross.svg";
import "../../stylesheet/components/catalogue/ActiveFilterItem.scss";

type ActiveFilterItemProps = {
  title: string;
  quoteTitle?: boolean;
  itemId: string;
  removeFilter: (id: string) => void;
};

const ActiveFilterItem: React.FC<ActiveFilterItemProps> = ({
  title,
  quoteTitle = false,
  itemId,
  removeFilter,
}) => {
  const handleClick = () => {
    removeFilter(itemId);
  };

  const getTitle = () => {
    if (quoteTitle) {
      return `"${title}"`;
    }
    return title;
  };

  return (
    <div className="active-filter-item flex-r" onClick={handleClick}>
      <p className="tag">{getTitle()}</p>
      <img src={cross} />
    </div>
  );
};

export default ActiveFilterItem;
